module.exports = __webpack_public_path__ + "static/scale-model-of-toledo-ohio-0ff31248f72394ce430661501a346240.png";